// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b2e35e2b","453":"897d95d8","455":"a4c4dede","977":"b2c3b07a"}[chunkId] + ".chunk.js";
};